
import { addPermissionsToRoute} from '@/myq-core';

const routes = {
  name: 'Product',
  icon: 'mdi-cube-outline',
  path: '/reports/product/',
  children: [
    {
      path: '/reports/product/productMixDrillDown',
      name: 'Product Mix',
      meta: { id: 'reports-productMix' },
      component: () => import('./ProductMix.vue'),
      ...addPermissionsToRoute(['productMix']),
    },
  ]
};

export default routes;